 import axios from 'axios';
 import LoyaltyPointTypeEntity from './loyalty-point-type-entity';
 import { APIResult } from '../http';
 import Service from '../service/service';
 import PendingRequestEntity from '../entities/pending-request-entity';

 class LoyaltyPointService extends Service {

   constructor () {
     super();
     this.types = null;
   }

   hydrate (point) {
     return new LoyaltyPointTypeEntity(
       point.id,
       point.amount,
       point.company_name,
       point.expires_at,
       point.factor,
       point.loyaltyable_id,
       point.loyaltyable_type,
       point.status,
       point.created_at,
       point.deleted_at,
       point.updated_at
     );
   }

   hydrateCollection (data) {
     var points = [];
     for (let point of data) {
       points.push(this.hydrate(point));
     }
     return points;
   }

   mapApiResponseForApiResult (meta) {
     if (meta.pagination) {
       return meta;
     }
     return {
       pagination: {
         page: {
           items: +meta.total,
           number: +meta.current_page,
           size: +meta.per_page
         },
         items: +meta.to - +meta.from,
         pages: +meta.last_page
       }
     };
   }

   getPending (page) {
     let pendingRequest = new PendingRequestEntity();

     let params = {
       'page': page || 1,
       'per_page': 10
     };

     pendingRequest.promise = axios.get('backend://users/loyalty-points/pending', {
       params,
       cancelToken: new axios.CancelToken(function executor (c) {
         pendingRequest.cancel = c;
       })
     })
       .then((response) => {
         var points = this.hydrateCollection(response.data.data);
         const meta = this.mapApiResponseForApiResult(response.data.meta);
         return new APIResult(points, meta);
       });

     return pendingRequest;
   }

   getComplete (page) {
     let pendingRequest = new PendingRequestEntity();

     let params = {
       'page': page || 1,
       'per_page': 10
     };

     pendingRequest.promise = axios.get('backend://users/loyalty-points/complete', {
       params,
       cancelToken: new axios.CancelToken(function executor (c) {
         pendingRequest.cancel = c;
       })
     })
      .then((response) => {
        var points = this.hydrateCollection(response.data.data, response.data.included);
        const meta = this.mapApiResponseForApiResult(response.data.meta);
        return new APIResult(points, meta);
      });

     return pendingRequest;
   }
 }

 export default new LoyaltyPointService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/loyalty-points/loyalty-point-service.js
 **/